import Close16 from '@carbon/icons-react/es/close/16';
import React from 'react';
import styled from 'styled-components';
import { Drawer as DrawerAtom } from 'components/atoms/drawer';

export const Drawer = styled(DrawerAtom).attrs({
  width: 360,
  placement: 'right',
  closeIcon: <Close16 />,
})`
  .ant-drawer-body {
    padding: 0;
  }
`;

export { CustomLayoutDrawerContent as DrawerContent } from 'components/atoms/drawer';
